/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import NavigationBar from '../components/NavBar'
import DivSingleWeek from '../components/DivSingleWeek'
import MakeDriver from './MakeEmployee'
import AutoSchedule from '../components/AutoSchedule'
import MakeLocalStorage from '../components/MakeLocalStorage'

MakeLocalStorage()

const WeekSchedule = (props) => {
    var CryptoJS = require("crypto-js");
    useEffect( () => {
        if (props.superUser) {

        } else {
            async function postData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            async function putData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'PUT', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            postData('https://backendpajamas.herokuapp.com/tracker/', {
                ID: props.user_id
            }).then( response => {
                let theDate = new Date()
                let theTime = `${theDate.getHours()}:${theDate.getMinutes()}:${theDate.getSeconds()}`
                if (response.data) {
                    response.data.forEach( ele => {
                        if (ele.date === new Date().toDateString()) {
                            let localPagesList = [...ele.pages_list, `${ele.pages_list.length}+rota+${theTime}`]
                            putData(`https://backendpajamas.herokuapp.com/trackeradditions/${ele._id}/`, {
                                pages_list: localPagesList
                            })
                        }
                    })
                }
            })
        }
    }, [])
    const [ drivers, setDrivers ] = useState(null)
    const [ schedule, setSchedule ] = useState(null)
    const [ selectedCity, setSelectedCity ] = useState('DBS2')
    const [ selectedAmount, setSelectedAmount ] = useState('14')
    const [ selectedSunday, setSelectedSunday ] = useState('14')
    const [ mathSunday, setMathSunday ] = useState('14')
    const [ varForMapping, setVarForMapping ] = useState('')
    const [ logicalGate, setLogicalGate ] = useState(false)
    const [ reloadGate, setReloadGate ] = useState(false)
    const [ submitPressed, setSubmitPressed ] = useState('Submit')
    const [ deletionScreen, setDeletionScreen ] = useState(false)
    const [ deleteDriverSelection, setDeleteDriverSelection ] = useState(null)
    const [ unDeleteDriverSelection, setUnDeleteDriverSelection ] = useState(null)
    const [ toggleText, setToggleText ] = useState('Delete Drivers')
    const [ autoScheduleToggle, setAutoScheduleToggle ] = useState(false)
    const [lockText, setLockText] = useState('Lock')

    const [lockButton, setLockButton] = useState(null)
    const [lockedWeekList, setLockedWeekList] = useState(null)
    const [reRender, setReRender] = useState(0)

    // eslint-disable-next-line no-extend-native
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }


    useEffect( () => {
        if (props.station) {
            if (props.station.length > 0) {
                setSelectedCity(props.station[0])
                // setSelectedCity()
            }
        }
    }, [])

    async function getData(url = '') {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            }
        });

        return response ? response.json() : console.log('no reponse')

    };
    async function postData(url = '', data={}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'POST', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
        });

        return response ? response.json() : console.log('no reponse')

    };
    async function putData(url = '', data={}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'PUT', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
        });

        return response ? response.json() : console.log('no reponse')

    };

    // handling the lock screen
    useEffect( () => {

        // handle each case -> 1 through 3 weeks
        let weekArray;
        // ONE WEEK
        if (selectedAmount === '7') {
            // grab the data associated with the week
            weekArray = [new Date(varForMapping).getWeek()]
        }
        
        // TWO WEEK
        if (selectedAmount === '14') {
            // grab the data associated with the week and next week
            weekArray = [new Date(varForMapping).getWeek(), new Date(varForMapping).getWeek()+1]

        }
        
        // THREE WEEK
        if (selectedAmount === '21') {
            // grab the data associated with the week and next week and thrid week
            weekArray = [new Date(varForMapping).getWeek(), new Date(varForMapping).getWeek()+1, new Date(varForMapping).getWeek()+2]
        }

        // grab all the associated data points
        async function awaitWeekLocks() {

            // for each date grab the data and make an array
            const result = Promise.all(weekArray.map( weekNumber => {
                // grab the data associated with the week
                return postData('https://backendpajamas.herokuapp.com/rotaweeksort/', {
                    week: weekNumber
                }).then( response => {
                    // return the array of viable data points
                    return response.rotaLocks
                })
            }))
            
            // flatten the array so it is easily looped through
            return result
        } 

        // call the async function
        awaitWeekLocks().then( response => {

            // flatten the array and grab the ones not overriden
            let weeksToDisable = response.flat().filter( responseData => responseData.overriden === false)

            // map the list of weeks to not display 
            setLockedWeekList(weeksToDisable.map(ele => ele.week_number))

            // make the unlock button if necessary
            weeksToDisable.find(mapDate => mapDate.week_number === new Date(varForMapping).getWeek().toString()) === undefined ? setLockText('Lock') : setLockText('Unlock')

        })

    }, [varForMapping, selectedAmount, reRender])

    // function for locking the page
    const handleLock = () => {
        // check if we are locking or unlocking
        if (lockText === 'Lock') {
            // check if there is a current instance of lock class already
            postData('https://backendpajamas.herokuapp.com/rotaweeksort/', {
                week: new Date(varForMapping).getWeek()
            }).then( response => {
                // if there is, change the overriden to false
                if (response.rotaLocks.length > 0) {
                    // find the data to change
                    let elementToChange = response.rotaLocks.find(ele => ele.overriden === true)

                    // if the data point is found ot edit
                    if (elementToChange) {
                        putData(`https://backendpajamas.herokuapp.com/rotalock/${elementToChange.validation_id}/`, {
                            overriden: false
                        }).then( response => {
                            setReRender(reRender+1)
                        })
                    }
                } else {
                    // if there isn't then make one
                    postData('https://backendpajamas.herokuapp.com/rotalock/', {
                        date: varForMapping,
                        week_number: new Date(varForMapping).getWeek(),
                        overriden: false
                    }).then( response => {
                        setReRender(reRender+1)
                    })
                }
            })
        } else {
            // handle unlocking - grab this weeks data
            postData('https://backendpajamas.herokuapp.com/rotaweeksort/', {
                week: new Date(varForMapping).getWeek()
            }).then( response => {
                // make sure there is data
                if (response.rotaLocks.length > 0) {

                    // find the one to change
                    let dataToChange = response.rotaLocks.find(ele => ele.overriden === false)

                    putData(`https://backendpajamas.herokuapp.com/rotalock/${dataToChange.validation_id}/`, {
                        overriden: true
                    }).then( response => {
                        setReRender(reRender+1)
                    })
                }
            })
        }
    }

    // handle making the lock button
    useEffect( () => {
        if (props.superUser || props.user_email === 'i.stoykov@h2ologistics.co.uk') {
            setLockButton(
                <div className='rota_top_spacer_lock'>
                    <button className='compliance_add_driver_button_submit' onClick={handleLock}>
                        <span className='span_in_complaince_button'>{lockText}</span> 
                    </button> 
                </div>
            )     
        } else {
            setLockButton(
                <div className='rota_top_spacer_lock'>
                    
                </div>
            )
        }
    }, [props, lockText])

    // dev data ... note to self... the following component only accepts format day:date
    // call this location rota, make it color coded by deopt, and trianing different color - 14 days rawr
    useEffect(() => {
        let myDate = new Date()
        while (myDate.getDay() > 0) {
            myDate.setDate(myDate.getDate() - 1)
        }
        setSelectedSunday(`${myDate.toLocaleDateString('en-GB')} | Week: ${myDate.getWeek()}`)
        setVarForMapping(myDate.toDateString())
        setMathSunday(myDate.toDateString())
    }, [])

    // set city
    const handleSelectSunday = (e, city, pick) => {
        setSelectedSunday(city)
        setVarForMapping(pick)
    }

    // get sundays
    const getSundays = () => {
        let sundays = []
        let currentDate = new Date(mathSunday)
        for (let i = -100; i < 100; i++) {
            let dateInner = new Date(currentDate.getFullYear(), currentDate.getMonth(), i)
            if (dateInner.getDay() === 0) {
                sundays.push(
                    <a href="#0" onClick={(e, city) => handleSelectSunday(e, `${dateInner.toLocaleDateString('en-GB')} | Week: ${dateInner.getWeek()}`, `${dateInner.toDateString()}`)}>
                        <li className='innerRotaFontMaker'>
                            {dateInner.toLocaleDateString('en-GB')} | Week: {dateInner.getWeek()}
                        </li>
                    </a>
                )
            }
        }
        return sundays
    }

    // dropdown menu options
    const optionsThree = getSundays()
    
    // set city
    const handleSelectCity = (e, city) => {
        setSelectedCity(city)
    }

    // set Amount
    const handleSelectAmount = (e, city) => {
        setSelectedAmount(city)
    }

    // new driver selection
    const handleMakeDriverPage = () => {
        setLogicalGate(true)
    }

    // get rid of the driver page
    const backToNormal = () => {
        setLogicalGate(false)
    }

    // toggle the delete driver tab
    const handleDeletionToggle = () => {
        deletionScreen === false ? setDeletionScreen(true) : setDeletionScreen(false)
        toggleText === 'Delete Drivers' ? setToggleText('Return') : setToggleText('Delete Drivers')
    }

    // make driver page
    var makeTheDriver
    makeTheDriver = (
        <>
        <MakeDriver user_name={props.user_name} user_email={props.user_email} user_id={props.user_id}/>
            <div className='absolute_return_button'>
                <button className='compliance_add_driver_button_submit' onClick={backToNormal}>
                    <span className='span_in_complaince_button'>Return</span> 
                </button>
            </div>
        </>
    )

    // handle delete submit
    const handleDeleteSubmit = (e, theDriver) => {
        let myDate = new Date()
        while (myDate.getDay() > 0) {
            myDate.setDate(myDate.getDate() - 1)
        }
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });

            return response ? response.json() : console.log('no reponse')

        };

        putData(`https://backendpajamas.herokuapp.com/drivers/${theDriver.driver_id}/`, {
            deleteButton: myDate.toDateString()
        }).then( (response) => {
            backToNormalDeletion()
        })
    }

    // handle un-delete submit
    const handleUnDeleteSubmit = (e, theDriver) => {
        let myDate = new Date()
        while (myDate.getDay() > 0) {
            myDate.setDate(myDate.getDate() - 1)
        }
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
            });

            return response ? response.json() : console.log('no reponse')

        };

        putData(`https://backendpajamas.herokuapp.com/drivers/${theDriver.driver_id}/`, {
            deleteButton: null
        }).then( (response) => {
            backToNormalDeletion()
        })
    }

    // handle get back from deletion screnn
    const backToNormalDeletion = () => {
        setDeleteDriverSelection(null)
        setDeletionScreen(false)
        setUnDeleteDriverSelection(null)
    }

    // handle making a delete driver screen
    var deleteTheDriver
    if (deleteDriverSelection) {
        deleteTheDriver = (
            <div className='new_driver_form_container'>
                <div className='delete_screen_container'>
                    <h1>Delete {deleteDriverSelection.name}?</h1>
                    <div className='deleteDriverButtons'>
                        <button className='compliance_add_driver_button_submit_delete' onClick={(e, theDriver) => handleDeleteSubmit(e, deleteDriverSelection)}>
                            <span className='span_in_complaince_button_delete'>Delete</span> 
                        </button>
                        <button className='compliance_add_driver_button_submit_return' onClick={backToNormalDeletion}>
                            <span className='span_in_complaince_button_return'>Return</span> 
                        </button>
                    </div>
                </div>
            </div>
        )
    }
    
    var unDeleteTheDriver
    if (unDeleteDriverSelection) {
        unDeleteTheDriver = (
            <div className='new_driver_form_container'>
                <div className='delete_screen_container'>
                    <h1>Bring back {unDeleteDriverSelection.name}?</h1>
                    <div className='deleteDriverButtons'>
                        <button className='compliance_add_driver_button_submit_delete' onClick={(e, theDriver) => handleUnDeleteSubmit(e, unDeleteDriverSelection)}>
                            <span className='span_in_complaince_button_delete'>Un-Delete</span> 
                        </button>
                        <button className='compliance_add_driver_button_submit_return' onClick={backToNormalDeletion}>
                            <span className='span_in_complaince_button_return'>Return</span> 
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    // grab child selection
    const deleteDriverFunction = (e, driverSelected) => {
        setDeleteDriverSelection(driverSelected)
    }

    // grab child selection in delete
    const deleteUnDriverFunction = (e, driverSelected) => {
        setUnDeleteDriverSelection(driverSelected)
    }

    // make auto schedule screen
    const handleAutoSchedule = () => {
        setAutoScheduleToggle(true)
    }

    // get rid of autoschedule screen
    const handleNonAuto = () => {
        setAutoScheduleToggle(false)
    }

    var content;
    if (!logicalGate && !deleteDriverSelection && !unDeleteDriverSelection && !autoScheduleToggle) {
        content = (
            <div className='home_content'>
                <NavigationBar title={`Location Rota${lockedWeekList ? lockedWeekList.length > 1 ? ` | Weeks ${lockedWeekList} Locked` : ` | Week ${lockedWeekList} Locked` : ''}`} superUser={props.superUser ? true : false} email={props.user_email}/>
                <div className='main_content_week_schedule'>
                    <div className='drop_down_bar_container_single_week'>
                        <nav className="menu_smaller" id="makeMeWhite">
                            <ol id="makeMeWhite">
                                <li className="menu-item" id="makeMeWhite"><a href="#0" id="makeMeWhite">{selectedCity}</a>
                                    <ol className="sub-menu" id="makeMeWhite">
                                        <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DBS2')}><a id="makeMeWhiteli" href="#0">DBS2</a></li>
                                        <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DSN1')}><a id="makeMeWhiteli" href="#0">DSN1</a></li>
                                        <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DEX2')}><a id="makeMeWhiteli" href="#0">DEX2</a></li>
                                        <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DXP1')}><a id="makeMeWhiteli" href="#0">DXP1</a></li>
                                        <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DCF1')}><a id="makeMeWhiteli" href="#0">DCF1</a></li>
                                    </ol>
                                </li>
                            </ol>
                        </nav>
                        <nav className="menu_smaller" id="makeMeWhite">
                            <ol>
                                <li className="menu-item" id="makeMeWhite" ><a href="#0" id="makeMeWhite">{selectedAmount}</a>
                                    <ol className="sub-menu" id="makeMeWhite">
                                        <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectAmount(e, '7')}><a id="makeMeWhiteli" href="#0">7</a></li>
                                        <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectAmount(e, '14')}><a id="makeMeWhiteli" href="#0">14</a></li>
                                        <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectAmount(e, '21')}><a id="makeMeWhiteli" href="#0">21</a></li>
                                    </ol>
                                </li>
                            </ol>
                        </nav>
                        <div id="demoRota">
                            <div className="wrapper">
                                <div className="content">
                                    <ul>
                                        {optionsThree}
                                    </ul>
                                </div>
                                <div className="parent" >{selectedSunday}</div>
                            </div>
                        </div>
                        {/* <nav className="menu">
                            <ol>
                                <li className="menu-item"><a href="#0">{selectedSunday}</a>
                                    <ol className="sub-menu">
                                        {optionsThree}
                                    </ol>
                                </li>
                            </ol>
                        </nav> */}
                        {lockButton}
                        <div className='rota_top_spacer'>
                            <button className='compliance_add_driver_button_submit' onClick={handleAutoSchedule}>
                                <span className='span_in_complaince_button'>Auto Schedule</span> 
                            </button> 
                        </div>
                        {/* <div className='rota_top_spacer_two'>
                            <button className='compliance_add_driver_button_submit' onClick={handleDeletionToggle}>
                                <span className='span_in_complaince_button'>{toggleText}</span> 
                            </button> 
                        </div> */}
                    </div>
                    <div className='scheduling_single_week_overlay'>
                        <DivSingleWeek 
                            drivers={drivers} 
                            schedule={schedule}
                            selectedDate={varForMapping}
                            divAmount={selectedAmount}
                            selectedCity={selectedCity ? selectedCity : 'DBS2'}
                            deletionDriver={deleteDriverFunction}
                            unDeletionDriver={deleteUnDriverFunction}
                            deleteDriverScreen={deletionScreen}
                            station={props.station}
                            userId={props.user_id}
                            autoToggle={autoScheduleToggle}
                            lockedWeekList={lockedWeekList}
                        />
                    </div>
                </div>
            </div>
        )
    } else if (logicalGate && !deleteDriverSelection && !unDeleteDriverSelection && !autoScheduleToggle) {
        content = (
            makeTheDriver
        )
    } else if (deleteDriverSelection && !unDeleteDriverSelection && !autoScheduleToggle) {
        content = (
            deleteTheDriver
        )
    } else if (unDeleteDriverSelection && !autoScheduleToggle) {
        content = (
            unDeleteTheDriver
        )
    } else if (autoScheduleToggle) {
        content = (
            <AutoSchedule 
                station={props.station}
                selectedCity={selectedCity ? selectedCity : 'DBS2'}
                superUser={props.superUser}
                returnMe={handleNonAuto}
            />
        )
    } else {
        content = ''
    }

    return (
        <>
            {content}
        </>
    )
}

export default WeekSchedule